<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<div class="clearfix topper">
			<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
			<div class="col-xs-12 col-md-10 col-md-offset-1 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_supportingactor_block_1.jpg" alt="Three Billboards Outside Ebbings, Missouri"></div>	
		</div>
		<div class="clearfix grid">
			<production-quote id="bestCinematographyProdQuote1" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote1"></production-quote>
			<div class="col-xs-12 col-md-6 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_supporting_actor_01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_supporting_actor_01.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/best_supporting_actor_01.webm" type='video/webm' />
				</video>
			</div>			
		</div>
		<div class="clearfix grid">
			<production-quote id="bestCinematographyProdQuote2" class="col-xs-12 col-md-6 col-md-push-6 no-pad" :prodQuote="productionQuote2"></production-quote>	
			<div class="col-xs-12 col-md-6 col-md-pull-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_supportingactor_block_2.jpg" alt="Three Billboards Outside Ebbings, Missouri"></div>					
		</div>
		<div class="clearfix"></div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import SliderImage from '../../components/SliderImage';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-supporting-actor',
	data: function() {
		return {
			heroContent: {
				"image": "best-original-supporting-actor-3b-lg",
				"mobileImage": "best-original-supporting-actor-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "Best Supporting Actor",
				"subHeader": ['WOODY HARRELSON', 'SAM ROCKWELL'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'Best Original Score',
				clickThruPath: ''
			},
			criticSlider1: [
				{
					text: "The cast is superb, with Woody Harrelson and Sam Rockwell right up there with Ms. McDormand in the pantheon of unforgettable performances.",
					author: "- THE WALL STREET JOURNAL"
				}			
			],
			productionQuote1: {
				text: "I think this is the best work Sam has ever done. There’s a real synthesis between Sam and Martin as an actor and director who have worked together repeatedly and are just getting better and better at it.",
				author: "Frances McDormand"
			},
			productionQuote2: {
				text: "We see a different side of Woody in this film. This is a more honest, sadder and realistic character. Woody brought to it not only his great humor but a strong sense of integrity and decency. The decency of Woody as a man shines through into Willoughby and I think that’s why it works so well.",
				author: "Martin McDonagh"
			}
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		}
	}
}
</script>


// WEBPACK FOOTER //
// BestSupportingActor.vue?4e5b9cf4